<template>
  <div v-if="!hideThis">
    <h3>Выберите Банк для зачисления средств.</h3>
<!--    <div v-if="device === 'iPhone'">-->
<!--&lt;!&ndash;      <label for="cdPaymentBase" class="instRadioInput">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="fakeWrap" v-bind:class="{active: cdPayment === 'base'}">&ndash;&gt;-->
<!--&lt;!&ndash;          <input type="radio" v-model="cdPayment" :value="'base'" id="cdPaymentBase">&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <span>Прикрепить скан платежных реквизитов</span>&ndash;&gt;-->
<!--&lt;!&ndash;      </label>&ndash;&gt;-->
<!--      <label for="cdPaymentSbp" class="instRadioInput">-->
<!--        <div class="fakeWrap" v-bind:class="{active: cdPayment === 'sbp'}">-->
<!--          <input type="radio" v-model="cdPayment" :value="'sbp'" id="cdPaymentSbp">-->
<!--        </div>-->
<!--        <span>Выбрать банк СБП</span>-->
<!--      </label>-->
<!--      <label for="cdPaymentb2pBindings" class="instRadioInput">-->
<!--        <div class="fakeWrap" v-bind:class="{active: cdPayment === 'b2pBindings'}">-->
<!--          <input type="radio" v-model="cdPayment" :value="'b2pBindings'" id="cdPaymentb2pBindings">-->
<!--        </div>-->
<!--        <span>Привязать карту</span>-->
<!--      </label>-->
<!--    </div>-->

    <div class="instErrMsg" v-if="statusVuex.code !== 0">{{statusVuex.msg}}</div>

    <instSbp v-show="cdPayment === 'sbp'"></instSbp>
    <instFotoAdd :fieldName="'BankAccount'" v-show="cdPayment === 'base'"></instFotoAdd>
<!--    <div v-show="device === 'iPhone' && cdPayment === 'b2pBindings'">-->
<!--      <p>Для привязки карты, нажмите подтвердить. Вы перейдете на экран привязки платежных средств.</p>-->
<!--    </div>-->
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instSelectBankInfo",
  data(){
    return {
      hideThis:false,
      device:''
    }
  },
  components:{
    instFotoAdd:()=>import('@/components/inst/instFotoAdd.vue'),
    instSbp:()=>import('@/components/inst/instSbp.vue')
  },
  methods:{
    hideIfIsset(){
      if (this.demandState.allPhotosStatusList.BankAccount > 0) {
        this.hideThis = true;
        this.$store.dispatch('saveSendData', {
          target: 'BankAccount',
          value: this.demandState.allPhotosStatusList.BankAccount
        });
        this.$store.dispatch('saveSendData', {
          target: 'cdPayment',
          value: 'base'
        });
      }
    }
  },
  computed: {
    ...mapState({
      statusVuex:state => state.Form.workData.cdPayment,
      valueVuex: state => state.Form.sendData.cdPayment,
      demandState: state => state.instForm.demandState,
    }),
    fieldStatus() {
      return this.valueVuex;
    },
    cdPayment: {
      get() {
        return this.valueVuex;
      },
      set(value) {
        this.$store.dispatch('saveSendData', {
          target: 'cdPayment',
          value: value
        });
      }
    },
  },
  mounted() {
    this.device = navigator.platform;
    this.hideIfIsset();
  }
}
</script>

<style scoped>
h3 {font-size: var(--font-size-20);margin: var(--font-size-24) auto;font-weight: 500}
</style>